import { render, staticRenderFns } from "./success-exam-alert.vue?vue&type=template&id=f8b20da0"
import script from "./success-exam-alert.vue?vue&type=script&lang=ts"
export * from "./success-exam-alert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports